<template>
  <div>
    <index-banner :src="require('@/assets/common/images/banner_02.png')" />
    <privacy-modal />
    <goods-class />
    <goods-brand />
    <goods-video />
    <goods-automation />
    <goods-industry />
    <goods-class-title
      :src="require('@/assets/images/footermovibot.png')"
      :width="750"
      :margintop="40"
      :marginbottom="70"
    />
  </div>
</template>
<script>
import HtmlFooter from "../components/common/HtmlFooter.vue";
import HtmlTop from "../components/common/HtmlTop.vue";
import NavMenu from "../components/common/NavMenu.vue";
import GoodsAutomation from "../components/index/GoodsAutomation.vue";
import GoodsBrand from "../components/index/GoodsBrand.vue";
import GoodsClass from "../components/index/GoodsClass.vue";
import GoodsClassTitle from "../components/index/GoodsClassTitle.vue";
import GoodsIndustry from "../components/index/GoodsIndustry.vue";
import GoodsVideo from "../components/index/GoodsVideo.vue";
import IndexBanner from "../components/IndexBanner.vue";
import PrivacyModal from "../components/index/PrivacyModal.vue";

export default {
  components: {
    HtmlTop,
    NavMenu,
    HtmlFooter,
    GoodsClass,
    IndexBanner,
    GoodsBrand,
    GoodsVideo,
    GoodsAutomation,
    GoodsIndustry,
    GoodsClassTitle,
    PrivacyModal
  },
  methods: {
    getgoodsIntroduction() {
      this.$api.goods.getgoodsIntroduction().then(res => {
        this.goodsIntroduction = res.data;
      });
    }
  },
  metaInfo: {
    title: "Movibot官网_工业机器人上下游供应链",
    meta: [
      {
        name: "keywords",
        content:
          "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案"
      },
      {
        name: "description",
        content:
          "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人零部件,商业智能服务,仓储物流,食品,医药,汽车,机械设备制造,电子、原材加工、新能源等行业提供工业自动化设备和行业解决方案"
      }
    ]
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/index.vue